module.exports = __webpack_public_path__ + "static/media/UploadIcon.1cedb6e9.svg";